import { render, staticRenderFns } from "./IncidentOsha.vue?vue&type=template&id=0a9896d1"
import script from "./IncidentOsha.vue?vue&type=script&lang=js"
export * from "./IncidentOsha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports